var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHair4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 87,
    viewBox: "0 0 138 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5368 28.0001C13.825 40.0208 8.99951 57.679 8.99951 80.5588C8.99951 81.9353 9.01698 83.2976 9.05192 84.6454C7.49792 85.0179 6.15468 85.6461 5.00193 86.4904C5.04712 45.6871 5.93895 31.226 23.5368 28.0001Z",
    className: "HairDark"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129 80.3062C129 81.6827 128.983 83.045 128.948 84.3928C130.502 84.7653 131.845 85.3935 132.998 86.2378C132.953 45.4345 132.061 30.9734 114.463 27.7475C124.175 39.7682 129 57.4265 129 80.3062Z",
    className: "HairDark"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00646 64.9684C32.2481 64.0087 52.325 41.2598 52.9833 2.71251C53.0019 1.62643 52.0961 0.725442 51.0101 0.700235C0.54446 -0.47116 0.00580597 0.532347 5.72205e-05 62.958C-4.19617e-05 64.0626 0.902447 65.0034 2.00646 64.9684Z",
    className: "Hair"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.916 23.9871C38.876 23.6218 26.1185 15.5523 25.0067 2.78662C24.9152 1.73677 25.7726 0.85666 26.8243 0.789779C55.9292 -1.0611 64.991 -0.229539 67.7526 9.54844C70.0364 -0.248494 78.6353 -1.06428 111.011 0.800582C112.069 0.861466 112.94 1.74434 112.832 2.79761C111.525 15.5542 96.7385 23.6185 68.9356 23.9868C68.5683 23.9917 68.2232 23.8953 67.926 23.724C67.6287 23.8954 67.2833 23.9918 66.916 23.9871Z",
    className: "Hair"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.994 64.9687C105.746 64.0116 85.6672 41.3197 85.0163 2.86996C84.9981 1.795 85.8843 0.898463 86.9587 0.858545C135.526 -0.945967 137.953 0.722331 137.999 62.9587C138 64.0633 137.098 65.0036 135.994 64.9687Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair4);
export default __webpack_public_path__ + "static/media/Hair 4.4094b20cd6af5f84180aea214db9bde4.svg";
export { ForwardRef as ReactComponent };